import Link from "next/link";
import Player from "@/components/LottiePlayer";


export default function Grid() {
  return (
    <section className="flex flex-col items-center justify-center font-['Inter'] px-8 sm:px-0 mx-auto xl:max-w-7xl lg:max-w-5xl md:max-w-3xl w-ful rounded-md">
      {/* <div className="flex flex-col justify-center items-center text-center py-8">
        <h3 className="w-full medium-title text-center font-['Inter']">
        Ready to transform your organization&lsquo;s data capabilities? 
        </h3>
        <p className="body-text max-w-xl mt-4">
        Explore our cutting-edge solutions designed to empower your organization&apos;s data journey and drive data-driven success. 
        </p>
      </div> */}
      <div className="xl:max-w-7xl lg:max-w-5xl md:max-w-3xl w-full mt-16 mb-8 grid grid-cols-1 md:grid-cols-2 gap-8 px-4">
        <div className="border border-2 shadow-md rounded-2xl hover:shadow-2xl hover:cursor-pointer">
          <Link href="/learn/faq">
            <div className="m-10 flex flex-col items-start">
              <div className='flex justify-start'>
                  <Player
                  autoplay
                  loop
                  src="assets/icons/confusion.json"
                  style={{ height: "50px", width: "50px" }}
                />
                </div>
              <h5 className="text-2xl pt-3">FAQS</h5>
              <div className="mt-3 bg-orange-400 rounded-xl h-1 w-20"></div>
              <h5 className="pt-3 max-w-full  body-text">
                Your data queries answered.
              </h5>
            </div>
          </Link>
        </div>
        <div className="border border-2 shadow-md rounded-2xl hover:shadow-2xl hover:cursor-pointer">
          <Link href="./glossary">
            <div className="m-10 flex flex-col items-start">
              <div className='flex justify-start'>
                  <Player
                  autoplay
                  loop
                  src="assets/icons/search2.json"
                  style={{ height: "50px", width: "50px", color: "orange" }}
                />
                </div>
              <h5 className="text-2xl pt-3">GLOSSARY</h5>
              <div className="mt-3 bg-orange-400 rounded-xl h-1 w-20"></div>
              <h5 className="pt-3 max-w-full  body-text">
               Demystifying data terms: definitions for the data world.
              </h5>
            </div>
          </Link>
        </div>
        <div className="border border-2 md:col-span-2 shadow-md rounded-2xl flex flex-col justify-end hover:shadow-2xl hover:cursor-pointer">
          <Link href="https://datahub.io/docs/dms/" target="_blank">
            <div className="m-10 flex flex-col items-start">
            <div className='flex justify-start'>
                  <Player
                  autoplay
                  loop
                  src="assets/icons/ai.json"
                  style={{ height: "50px", width: "50px" }}
                />
                </div>
              <h5 className="text-2xl pt-3">Tech Knowledge Base</h5>
              <div className="mt-3 bg-orange-400 rounded-xl h-1 w-20"></div>
              <h5 className="pt-3 max-w-full  body-text">
               Learn about Datopian&apos;s technical solutions.
              </h5>
            </div>
          </Link>
        </div>
        <div className="border border-2 shadow-md rounded-2xl hover:shadow-2xl hover:cursor-pointer">
          <Link href="./knowledge-base">
            <div className="m-10 flex flex-col items-start">
            <div className='flex justify-start'>
                  <Player
                  autoplay
                  loop
                  src="assets/icons/hexagonal2.json"
                  style={{ height: "50px", width: "50px" }}
                />
                </div>
              <h5 className="text-2xl pt-3">Data Management Maturity Model</h5>
              <div className="mt-3 bg-orange-400 rounded-xl h-1 w-20"></div>
              <h5 className="pt-3 max-w-full  body-text">
               A guide to our data management maturity model and unique framework for building reliable, flexible systems for organizing and integrating data.
              </h5>
            </div>
          </Link>
        </div>
        <div className="border-2 shadow-md rounded-2xl hover:shadow-2xl hover:cursor-pointer">
          <Link href="./playbook">
            <div className="m-10 flex flex-col items-start">
              <div className='flex justify-start'>
                  <Player
                  autoplay
                  loop
                  src="assets/icons/math.json"
                  style={{ height: "50px", width: "50px" }}
                />
                </div>
              <h5 className="text-2xl pt-3">Playbook</h5>
              <div className="mt-3 bg-orange-400 rounded-xl h-1 w-20"></div>
              <h5 className="pt-3 max-w-full  body-text">
               The heart of Datopian: the way to do things.
              </h5>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}
